import { createReducer, on } from "@ngrx/store";

import { ProductActions } from "./index";
import { Product } from "./product.model";

export interface ProductState {
  availableProductsDetails: Product[] | null;
}

export const initialState: ProductState = {
  availableProductsDetails: [],
};

export const productReducer = createReducer(
  initialState,

  on(
    ProductActions.getAvailableProductDetailsSuccess,
    (state, { products }) => ({
      ...state,
      availableProductsDetails: products,
    })
  ),

  on(ProductActions.createProductSuccess, (state, { product }) => ({
    ...state,
    availableProductsDetails: [
      product,
      ...(state.availableProductsDetails || []),
    ],
  })),

  on(ProductActions.editProductSuccess, (state, { product }) => ({
    ...state,
    availableProductsDetails: [
      product,
      ...(state.availableProductsDetails || []),
    ],
  }))
);
